var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  测试页面12\n  "),_c('div',{staticStyle:{"border":"1px solid red","height":"100px"}},[_c('el-empty',{attrs:{"description":"暂无回访图片"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }